import { render } from "./AiBot.vue?vue&type=template&id=580d0ae3"
import script from "./AiBot.vue?vue&type=script&lang=js"
export * from "./AiBot.vue?vue&type=script&lang=js"

import "./AiBot.vue?vue&type=style&index=0&id=580d0ae3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__